import styled from '@emotion/styled';

const radius = '20px';

export const Day = styled.button`
	text-align: center;
	border: none;
	background: transparent;
	margin-bottom: 8px;
	cursor: pointer;
	border-radius: ${radius};
	padding: 8px 4px;
	color: var(--token-color-colour-text-primary);

	transition:
		background-color 0.2s linear,
		color 0.2s linear;

	&:hover {
		background-color: var(--token-color-colour-background-secondary);
	}

	&[disabled] {
		color: var(--token-color-text-secondary);
		cursor: default;

		&:hover {
			background-color: transparent;
		}
	}

	&.today {
		font-weight: 700;
	}

	&.selection-type--range-start {
		background-color: var(--token-color-colour-background-inverted-primary);
		color: var(--token-color-colour-text-inverted-primary);
		border-radius: ${radius} 0 0 ${radius};
	}

	&.selection-type--range-middle {
		background-color: var(--token-color-colour-background-secondary);
		border-radius: 0;
	}

	&.selection-type--range-end {
		background-color: var(--token-color-colour-background-inverted-primary);
		color: var(--token-color-colour-text-inverted-primary);
		border-radius: 0 ${radius} ${radius} 0;
	}

	&.selection-type--single {
		background-color: var(--token-color-colour-background-inverted-primary);
		color: var(--token-color-colour-text-inverted-primary);
	}
`;
